import { Box, Tab, Tabs } from "@mui/material";
import * as React from "react";
import OverviewTab from "../../components/admin/overview_tab/overview_tab";
import OverrideTab from "../../components/admin/override_tab/override_tab";

export default function AdminPage({ required_privilege }) {
  const [tab, setTab] = React.useState(0);

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: "divider", backgroundColor: "white", pl: 3 }}>
        <Tabs
          value={tab}
          onChange={(event, newValue) => setTab(newValue)}
          aria-label="basic tabs example"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Overview" value={0} />
          <Tab label="Manual Override" value={1} />
        </Tabs>
      </Box>

      {tab === 0 ? <OverviewTab required_privilege={required_privilege} /> : null}
      {tab === 1 ? <OverrideTab required_privilege={required_privilege} /> : null}
    </>
  );
}
